<template>
	<main class="u-flex">
		<posts type="single"></posts>
	</main>
</template>

<script>
// Import components
import posts from '@/components/posts/posts'

export default {
	name: 'posts-page',
	components: {
		posts
	}
}
</script>



// WEBPACK FOOTER //
// postPage.vue?197addc6